import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { getImagePath } from '../../utils/imagePath';

const AbujaBoulevard = () => {
  const [activeImage, setActiveImage] = useState(0);

  const facilityData = {
    name: 'Abuja Boulevard',
    category: 'Dining',
    description: 'Experience fine dining with a view, offering local and international cuisine in an elegant setting.',
    longDescription: 'Abuja Boulevard is our premier dining destination, featuring a sophisticated atmosphere with panoramic views of the club grounds. Our expert chefs prepare a diverse menu blending local Nigerian flavors with international culinary traditions. Perfect for romantic dinners, business meetings, or family celebrations.',
    images: [
      getImagePath('images/company/abuja-boulevard.jpg'),
      getImagePath('images/company/club-constitution1.jpg'),
      getImagePath('images/company/abuja-boulevard.jpg')
    ],
    icon: 'fa-building',
    capacity: '150 guests',
    hours: 'Lunch: 12pm - 3pm | Dinner: 6pm - 11pm',
    features: [
      'Fine Dining Restaurant',
      'Private Dining Rooms',
      'Full Bar Service',
      'Outdoor Terrace',
      'Wine Cellar',
      'Event Catering',
      'Live Music Fridays',
      'Sunday Brunch'
    ],
    amenities: ['Valet Parking', 'Wheelchair Accessible', 'Reservations Required', 'Private Parking'],
    contact: {
      phone: '+234 905 584 6379',
      email: 'abujaboulevard@nlngraclub.com',
      extension: '101'
    },
    menu: ['Continental', 'African', 'Seafood', 'Grill'],
    chef: 'Chef Michael Okafor'
  };

  return (
    <div className="facility-detail-page">
      {/* Hero Section */}
      <section className="facility-detail-hero">
        <div className="hero-background">
          <img src={facilityData.images[0]} alt={facilityData.name} />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link to="/facilities" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Facilities
            </Link>
            <span className="facility-category">{facilityData.category}</span>
            <h1 className="facility-title">{facilityData.name}</h1>
            <p className="facility-subtitle">{facilityData.description}</p>
          </motion.div>
        </div>
      </section>

      {/* Facility Content */}
      <section className="facility-content-section">
        <div className="container">
          <div className="facility-grid">
            {/* Left Column - Images */}
            <div className="facility-gallery">
              <div className="main-image">
                <img 
                  src={facilityData.images[activeImage]} 
                  alt={facilityData.name} 
                />
              </div>
              <div className="image-thumbnails">
                {facilityData.images.map((img, index) => (
                  <button 
                    key={index} 
                    className={`thumbnail-btn ${activeImage === index ? 'active' : ''}`}
                    onClick={() => setActiveImage(index)}
                  >
                    <img src={img} alt={`${facilityData.name} ${index + 1}`} />
                  </button>
                ))}
              </div>
            </div>

            {/* Right Column - Details */}
            <div className="facility-details">
              <div className="detail-section">
                <h2>About {facilityData.name}</h2>
                <p className="facility-description">{facilityData.longDescription}</p>
              </div>

              <div className="detail-section">
                <h3>Key Features</h3>
                <ul className="features-list">
                  {facilityData.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="info-grid">
                <div className="info-card">
                  <i className="fas fa-clock"></i>
                  <h4>Hours</h4>
                  <p>{facilityData.hours}</p>
                </div>
                <div className="info-card">
                  <i className="fas fa-users"></i>
                  <h4>Capacity</h4>
                  <p>{facilityData.capacity}</p>
                </div>
                <div className="info-card">
                  <i className="fas fa-phone"></i>
                  <h4>Contact</h4>
                  <p>{facilityData.contact.phone} ext. {facilityData.contact.extension}</p>
                </div>
              </div>

              <div className="additional-info">
                <div className="info-row">
                  <span className="info-label">Cuisine:</span>
                  <span className="info-value">{facilityData.menu.join(' • ')}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Head Chef:</span>
                  <span className="info-value">{facilityData.chef}</span>
                </div>
              </div>

              <div className="action-buttons">
                <Link to="/login" className="btn btn-primary btn-large">
                  <i className="fas fa-calendar-check"></i> Make a Reservation
                </Link>
                <Link to="/contact" className="btn btn-outline btn-large">
                  <i className="fas fa-envelope"></i> Inquire
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AbujaBoulevard;